import React, {memo} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fonts} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface MessageTruncatedWarningProps {
  onOpenMessageRenderClick: Handler;
}

/*
 * Style.
 */

const StyledWarningDiv = styled.div`
  padding: 12px 16px;

  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 2px;
  align-items: baseline;
  justify-content: start;

  color: ${(p) => p.theme.greys.black};
  font-family: ${fonts.system};
`;

/*
 * Component.
 */

export const MessageTruncatedWarning = memo<MessageTruncatedWarningProps>(({onOpenMessageRenderClick}) => (
  <StyledWarningDiv>
    <div>
      <Trans id="messageviewer-truncated-message">This message was truncated.</Trans>
    </div>
    <Button variant={ButtonVariantsEnum.LINK} size={VisualSizesEnum.SMALL} onClick={onOpenMessageRenderClick}>
      <Trans id="messageviewer-truncated-action">View entire message</Trans>
    </Button>
  </StyledWarningDiv>
));
